import { useState } from "react"
import { Navigate, Outlet, useLocation } from "react-router-dom"
import AdminHeader from "@/components/layout/AdminHeader"
import AdminSidebar from "@/components/layout/AdminSidebar"
import Loading from "@/components/common/Loading"
import { useAdminSession } from "@/domain/admin/hooks/AdminAuthHook"

/**
 * 관리자 레이아웃.
 *
 * 진입 시 저장된 토큰으로 세션을 확인하고, 세션이 없으면 로그인 화면으로 보낸다.
 * 서버도 "/api/v1/bo/" 를 토큰 없이 통과시키지 않으므로 이 가드는 UX 를 위한 1차 방어다.
 */
export default function AdminLayout() {
  const location = useLocation()
  const { state, logout } = useAdminSession()
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [todayIso] = useState(() => new Date().toISOString())

  function onOpenSidebar() {
    setIsSidebarOpen(true)
  }

  function onCloseSidebar() {
    setIsSidebarOpen(false)
  }

  function onLogout() {
    logout()
  }

  if (!state.isChecked) {
    return <Loading label="세션을 확인하는 중" />
  }

  if (!state.account) {
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname }}
        replace
      />
    )
  }

  return (
    <div className="min-h-dvh bg-app-secondary-200 text-app-text-400">
      <a
        href="#main"
        className="focus-ring sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-app-secondary-100 focus:px-4 focus:py-2"
      >
        본문 바로가기
      </a>

      <AdminSidebar
        isOpen={isSidebarOpen}
        onClose={onCloseSidebar}
      />

      <div className="min-h-dvh lg:pl-72">
        <AdminHeader
          todayIso={todayIso}
          account={state.account}
          onOpenSidebar={onOpenSidebar}
          onLogout={onLogout}
        />
        <main
          id="main"
          tabIndex={-1}
          className="p-5 sm:p-8"
        >
          <Outlet />
        </main>
      </div>
    </div>
  )
}
